import React, { useContext } from 'react';
import { IconProps } from '../iconProps';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';

export default function IconJSON({
  isAutoscallable = true,
  sizeKey = '18x22',
  onClick,
  style,
}: IconProps) {
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      className={cx('icon', { 'icon-disabled': !onClick })}
      onClick={onClick}
      style={style}
      width={w}
      height={h}
      viewBox="0 0 19 22"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4259 14.4342C9.84425 14.4342 9.50787 14.9743 9.50787 15.6948C9.50787 16.4219 9.85775 16.9334 10.4304 16.9334C11.012 16.9334 11.3439 16.3944 11.3439 15.6728C11.3439 15.0084 11.0165 14.4342 10.4259 14.4342Z"
        fill="#333333"
      />
      <path
        d="M11.75 0H2.75C2.15326 0 1.58097 0.231785 1.15901 0.644365C0.737053 1.05694 0.5 1.61652 0.5 2.2V19.8C0.5 20.3835 0.737053 20.9431 1.15901 21.3556C1.58097 21.7682 2.15326 22 2.75 22H16.25C16.8467 22 17.419 21.7682 17.841 21.3556C18.2629 20.9431 18.5 20.3835 18.5 19.8V6.6L11.75 0ZM5.02475 16.1744C5.02475 17.2315 4.50613 17.6 3.67475 17.6C3.47675 17.6 3.218 17.5681 3.04812 17.512L3.14487 16.8355C3.26187 16.874 3.41375 16.9015 3.58475 16.9015C3.94363 16.9015 4.16975 16.742 4.16975 16.1645V13.8303H5.02588L5.02475 16.1744ZM6.66613 17.5945C6.233 17.5945 5.80438 17.4845 5.59175 17.369L5.76612 16.6749C5.99563 16.7904 6.35225 16.907 6.71788 16.907C7.11163 16.907 7.31863 16.7464 7.31863 16.5055C7.31863 16.2734 7.13975 16.1414 6.68412 15.9819C6.05188 15.7674 5.64125 15.4253 5.64125 14.8863C5.64125 14.2527 6.18238 13.7676 7.07788 13.7676C7.50538 13.7676 7.81925 13.8556 8.0465 13.9557L7.853 14.6322C7.70113 14.5607 7.43113 14.4562 7.05988 14.4562C6.68863 14.4562 6.5075 14.6212 6.5075 14.8137C6.5075 15.0502 6.72125 15.1558 7.21287 15.3373C7.88338 15.5793 8.19838 15.9203 8.19838 16.4439C8.1995 17.0665 7.70788 17.5945 6.66613 17.5945ZM10.3854 17.6C9.25925 17.6 8.60113 16.7695 8.60113 15.7124C8.60113 14.5992 9.32788 13.7676 10.4484 13.7676C11.6128 13.7676 12.2495 14.6212 12.2495 15.6453C12.2484 16.863 11.4946 17.6 10.3854 17.6ZM15.9507 17.5395H15.0485L14.2374 16.1073C13.9947 15.6825 13.7751 15.2456 13.5793 14.7983L13.5612 14.8038C13.5849 15.2933 13.5961 15.8169 13.5961 16.423V17.5406H12.8075V13.8303H13.8099L14.5985 15.1899C14.8235 15.5793 15.0485 16.0424 15.2195 16.4604H15.2353C15.179 15.9709 15.1621 15.4704 15.1621 14.9138V13.8303H15.9519L15.9507 17.5395ZM10.625 7.7V2.2L16.25 7.7H10.625Z"
        fill="#333333"
      />
    </svg>
  );
}
